import React = require("react")
import { PublicAmorgUser, Activity, ActivityParticipantRole, assertNever, ActivityParticipantData } from "../../../amorg-common";
import { Button } from "../../../designSystem/button/Button";
import { Grid, Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Modal } from "../../../designSystem/Modal";
import { TestBox } from "../activities/MeetingDetailsPanel";
import { ParticipantEditor } from "./ParticipantEditor";
import { InfoChip } from "../../../designSystem/Chip";

type MeetingParticipantListProps = {
    users: PublicAmorgUser[];
    activity: Activity;
    onParticipantsUpdated(): void;
}
export function MeetingParticipantList(props: MeetingParticipantListProps): JSX.Element {

    const [modal, setModal] = React.useState<{role: ActivityParticipantRole} | null>(null);

    function handleClickEditParticipants(role:ActivityParticipantRole) {
        setModal({role});
    }

    function handleParticipantsUpdated()
    {
        props.onParticipantsUpdated();
        if(modal === null)
        {
            throw new Error('Modal role is null when updating participants');
        }
        else if(modal.role === 'facilitator' || modal.role === 'minuteTaker')
        {
            // Close the modal - only one can be selected for these roles, so the user is done after selecting one
            setModal(null);
        }
        else if(modal.role === 'participant')
        {
            // Keep the modal open - many can be selected for this role, so the user may want to add more
        }
        else
        {
            assertNever(modal.role);
        }
    }

    return (
        <>
            <Grid gridTemplateColumns={3} gap={16}>
                <Flex flexDirection="column" gap={8} width="100%">
                    <TestBox>Facilitator / mødeleder <Button variant="text" onClick={()=>handleClickEditParticipants('facilitator')} icon="interface_actions_edit" /></TestBox>
                    <ParticipantPillList role="facilitator" participants={props.activity.participants} />
                </Flex>
                <Flex flexDirection="column" gap={8} width="100%">
                    <TestBox>Referent <Button variant="text" onClick={()=>handleClickEditParticipants('minuteTaker')} icon="interface_actions_edit" /></TestBox>
                    <ParticipantPillList role="minuteTaker" participants={props.activity.participants} />
                </Flex>
                
                <Flex flexDirection="column" gap={8} width="100%">
                    <TestBox>Deltagere <Button variant="text" onClick={()=>handleClickEditParticipants('participant')} icon="interface_actions_edit" /></TestBox>
                    <ParticipantPillList role="participant" participants={props.activity.participants} />
                </Flex>
                
            </Grid>
            <Flex flexDirection="row" gap={16}>

                
                <Modal 
                    title={"Rediger deltagere"}
                    content={
                        <ParticipantEditor
                            activity={props.activity}
                            defaultAddRole={modal?.role ?? 'participant'}
                            onParticipantsUpdated={handleParticipantsUpdated}
                            onCancel={() => setModal(null)} />
                    }
                    showModal={modal !== null}
                    onCancel={() => setModal(null)}/>
               
            </Flex>
            </>
    );
}

function ParticipantPillList({role, participants}: {role: ActivityParticipantRole, participants:ActivityParticipantData[]}): JSX.Element {
    return (
        <>
            {participants.filter(p => p.activityRole === role).map(p => 
                <InfoChip key={p.id} variant="outlined">
                        <span>{p.name}{p.type.value === 'external' ? ' (ekstern)' : ''}</span>
                </InfoChip>
            )}
        </>
    );
}